import { useSelector } from "react-redux";
import { URLS } from "common/constants";
import {
  formatCompany,
  type FormattedCompanyDetails,
} from "components/job/JobLayout/JobCompanyDetails/helpers";
import jobSelectors from "store/selectors/job";
import { selectors } from "store";

export interface JobCompanyDetailsPropsHook extends FormattedCompanyDetails {
  isLoading: boolean;
  link: string;
  cid: string;
}

export default function useJobCompanyDetailsProps(): JobCompanyDetailsPropsHook {
  const company = useSelector(jobSelectors.getJobCompany);
  const isLoading = useSelector(selectors.getIsLoading);

  const details = formatCompany(company);

  const cid = company?.cid || "";

  const link = URLS.COMPANY.replace("{id}", cid);

  return {
    ...details,
    isLoading,
    link,
    cid,
  };
}
